(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["r2pay-merchant-panel"] = factory();
	else
		root["r2pay-merchant-panel"] = factory();
})(globalThis, () => {
return 